import React from 'react';
// import BaseLayout from './layout/BaseLayout';
import { Navigate, useRoutes } from 'react-router-dom';
import Baselayout from './layout/Baselayout';
import Chat from './pages/chat/Chat';
import Login from './pages/login/Login';
import ProtectedLayout from './layout/ProtectedLayout';
import Music from './pages/music/Music';

export default function Router(props) {

  return useRoutes([
    {
      path: '/',
      element: <Music />,
    },
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: '/',
      element: <ProtectedLayout />,
      children: [
        {
          path: '/',
          element: <Baselayout />,
          children: [
            {
              path: '/chat',
              element: <Chat />,
            },
            {
              path: '/chat/:id',
              element: <Chat />,
            },
          ],
        },
      ],
    },
    // {
    //   path: '*',
    //   element: <Navigate to="/login" replace />
    // }
  ]);
}
